import React from "react"
import { Flex } from "@chakra-ui/react"

import JobListing from "@components/JobListing"

interface Listing {
  position: string
  location: string
  description: any
}

interface JobListingsProps {
  openPositions: Listing[]
}

const JobListings: React.FC<JobListingsProps> = ({ openPositions }) => {
  return (
    <Flex flexDir="column">
      {openPositions?.map((position, idx) => (
        <JobListing key={idx} {...position} />
      ))}
    </Flex>
  )
}

export default JobListings
